var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('feature-card-basic',{attrs:{"layer":_vm.layer},scopedSlots:_vm._u([(_vm.collisionsVisible)?{key:"top",fn:function(){return [_c('wat-sew-collisions-info',{attrs:{"layer-id":_vm.layerId,"feature-id":_vm.currentFeatureId}})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }